import { render, staticRenderFns } from "./RewardProgramStatement.vue?vue&type=template&id=251edec6&scoped=true"
import script from "./RewardProgramStatement.vue?vue&type=script&lang=js"
export * from "./RewardProgramStatement.vue?vue&type=script&lang=js"
import style0 from "./RewardProgramStatement.vue?vue&type=style&index=0&id=251edec6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "251edec6",
  null
  
)

export default component.exports